/* foreach.js
   –––––––––––––––––––––––––––––––––––––––––––––––––––– 
   Version : 1.1.0
   Repo    : github.com/toddmotto/foreach
   Author  : Todd Motto
   License : MIT
   –––––––––––––––––––––––––––––––––––––––––––––––––––– */
var forEach=function(a,b,c){if("[object Object]"===Object.prototype.toString.call(a))for(var d in a)Object.prototype.hasOwnProperty.call(a,d)&&b.call(c,a[d],d,a);else for(var e=0,f=a.length;f>e;e++)b.call(c,a[e],e,a)};